import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@myrealtrip/fetch';

/* eslint-disable @typescript-eslint/naming-convention */
interface HotKeyword {
  keyword: string;
  view_count: number;
  keyword_date: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

interface HotKeywordData {
  date: string;
  keywords: HotKeyword[];
}

interface HotKeywordResponse {
  data: HotKeywordData;
  meta: Record<string, unknown>;
  result: { status: number; message: string; code: string };
}

const fetchHotKeywords = () => {
  return axiosInstance.get<HotKeywordResponse>('/search/keyword/v1/hotkeyword');
};

export default function useGetHotKeywords() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['fetchHotKeywords'],
    queryFn: fetchHotKeywords,
    select: (response) => response.data.data,
  });

  return {
    keywords: data?.keywords ?? [],
    date: data?.date ?? '',
    isLoading,
    isError,
  };
}
